import React from 'react';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { P2 } from 'styleguide/Texts';
import { t } from 'translations/t';

const Container = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  padding: 0 32px;
  margin-top: 16px;
`;

interface Props {
  username: string;
}

export const PrivateWorkout = ({ username }: Props) => {
  return (
    <Container>
      <SvgPrivateWorkout />
      <P2 style={{ marginTop: 16, textAlign: 'center' }}>
        {t('web.workoutDetails.privateWorkout.title', { username })}
      </P2>
    </Container>
  );
};

function SvgPrivateWorkout() {
  return (
    <svg width="66px" height="66px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <circle stroke="#E4E6E9" strokeWidth={1.5} cx={32} cy={32} r={32} />
        <path
          d="M39.759 28.738H37.69v-5.47c0-3.456-2.816-6.268-6.278-6.268-3.461 0-6.278 2.812-6.278 6.268v5.47h-2.067c-1.14 0-2.068.927-2.068 2.065v12.769c0 1.138.928 2.064 2.068 2.064h16.69c1.14 0 2.068-.926 2.068-2.064V30.803a2.068 2.068 0 00-2.067-2.065zm-13.245-5.47a4.901 4.901 0 014.9-4.892c2.7 0 4.899 2.195 4.899 4.892v5.47h-9.8v-5.47zm13.934 20.304a.69.69 0 01-.69.688h-16.69a.69.69 0 01-.69-.688V30.803c0-.38.31-.688.69-.688h16.69c.38 0 .69.308.69.688v12.769z"
          fill="#008CFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
